export const feedbackEnvironment = {
  GOOGLE_ANALYTICS: {
    domain: 'auto',
    GTM: ''
  }
};
